import { styled } from "@mui/material/styles";
import Typography from "@bmi-digital/components/typography";

const PREFIX = "selectedRoof";

export const classes = {
  roofIllustration: `${PREFIX}-roofIllustration`,
  breakRow: `${PREFIX}-breakRow`,
  topPadding: `${PREFIX}-topPadding`
};

export const SectionTitle = styled(Typography)(({ theme }) => ({
  marginRight: "auto",
  marginBottom: "18px",
  fontWeight: "700",
  lineHeight: 1.2,

  [`&.${classes.topPadding}`]: {
    marginTop: "24px",

    [theme.breakpoints.down(1024)]: {
      marginTop: "18px"
    }
  }
}));

export const Container = styled("div")(({ theme }) => ({
  width: "100%",
  border: `1px solid ${theme.colours.storm}`,
  padding: "18px 24px",
  borderRadius: "3px",
  display: "flex",
  alignItems: "center"
}));

export const RoofIllustrationBlock = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "10px 11.5px",
  marginRight: "15px",

  [`& .${classes.roofIllustration}`]: {
    width: "96px",
    height: "auto"
  },

  [theme.breakpoints.down("sm")]: {
    marginRight: "22px"
  }
}));

export const RoofName = styled(Typography)(({ theme }) => ({
  color: theme.colours.cyan500,
  marginTop: "6px"
}));

export const RoofDimensionsBlock = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(5, minmax(126px, max-content))",
  rowGap: "30px",
  columnGap: "28px",

  [theme.breakpoints.down(1096)]: {
    gridTemplateColumns: "repeat(4, minmax(126px, max-content))"
  },

  [theme.breakpoints.down(972)]: {
    gridTemplateColumns: "repeat(3, minmax(126px, max-content))"
  },

  [theme.breakpoints.down(760)]: {
    gridTemplateColumns: "repeat(2, minmax(126px, max-content))"
  },

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(1, max-content)",
    rowGap: "18px"
  }
}));

export const DimensionWrapper = styled("div")({
  lineHeight: 1.2,
  fontSize: "1rem",
  display: "flex",
  padding: "0 8px",

  [`&.${classes.breakRow}`]: {
    gridColumnStart: "1"
  }
});

export const DimensionLabel = styled("span")({
  fontWeight: 700,
  marginRight: "14px"
});

export const DimensionValue = styled("span")({
  marginLeft: "auto"
});
